import React from 'react';
import styled from 'styled-components';

const Footer = () => {  
  return (
    <FooterContainer>
      <FooterContent>
        {/* <PoweredBy>
          Powered by Opplane
        </PoweredBy> */}
      </FooterContent>
    </FooterContainer>
  );
};

// Styled components
const FooterContainer = styled.footer`
  background-color: ${props => props.theme.colors.verizonBlack};
  color: ${props => props.theme.colors.verizonWhite};
  padding: ${props => props.theme.spacing.md};
  margin-top: auto;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: ${props => props.theme.spacing.sm};
  }
`;

export default Footer;
